

import { useState } from 'react'
import clsx from 'clsx'
import { Modal } from 'react-bootstrap'
import { downloadReport } from '../api'
import { Downloadloader, downloadCsv } from '../../../component/helper'


/**
 * ReportButton component
 * Renders a button for downloading reports and opening a confirmation modal.
 * Handles CSV download, report download, and modal state for selecting days.
 *
 * Props:
 * @param {string} title - Button and modal title.
 * @param {number} order - Order number displayed in the button.
 * @param {string} background - Background color for the button.
 * @param {boolean} reportPopup - If true, shows modal for day selection.
 * @param {string} link - Optional link for download.
 * @param {object} download_url - Object mapping days to download URLs.
 * @param {string|number} report_id - Report identifier for download.
 */
const ReportButton = ({ title, order = 1, background, reportPopup = false, link, download_url = null, report_id }) => {
    const styles = {
        borderRadius: '0.475rem',
        boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
        backgroundColor: '#fff',
        color: '#7e8299',
        fontWeight: '500',
        margin: '0',
        width: 'auto',
        padding: '1rem 2rem',
        top: 'calc(50% - 2rem)',
        left: 'calc(50% - 4rem)',
    }
    const [loader, setLoader] = useState(false)
    const [days, setDays] = useState(1)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const confirmationPopup = (type) => {
        setIsModalOpen(type)
    }

    const downloadFile = (report_id, name) => {
        setLoader(true);

        downloadReport(report_id).then((d) => {
            // Get the current date and time
            getFileNameFromUrl(d, name)
            // Delay setting loader to false to ensure download is completed
            setTimeout(() => {
                setLoader(false);
            }, 500);
        });
    };

    const getFileNameFromUrl = (d, name) => {
        const currentDate = new Date();
        // Format the date and time
        const formattedDate = currentDate.toISOString().slice(0, 10); // Format: YYYY-MM-DD
        const formattedTime = currentDate.toTimeString().slice(0, 8).replace(/:/g, ''); // Format: HHMMSS
        // Combine date and time to create a unique timestamp
        const timestamp = formattedDate + '_' + formattedTime;
        // Combine the timestamp with the file name
        const fileName = name + '_' + timestamp + '.csv';
        downloadCsv({
            data: d,
            fileName: fileName,
            fileType: 'text/csv'
        });
    };
    // const downloadFileByDays = (report_id, days, name = 'kyc') => {
    //     setLoader(true);

    //     downloadCSv(report_id + '/' + days).then((d) => {
    //         // Get the current date and time
    //         getFileNameFromUrl(d, name)
    //         // Delay setting loader to false to ensure download is completed
    //         setTimeout(() => {
    //             setLoader(false);
    //         }, 500);
    //     });
    // };
    return (<>

        {reportPopup ?
            <button type='button' onClick={() => confirmationPopup(true)} style={{ background: background }} className="btn btn-sm  text-white ">
                <div className='d-flex align-items-center justify-content-center fs-6 ps-0 pe-0'>
                    <div class="symbol symbol-25px symbol-circle me-2">
                        <span class={`symbol-label fs-6 fw-semibold text-dark bg-white`}>{order}
                        </span>

                    </div> {title}
                    <i className="bi-solid bi-chevron-right"></i>
                </div>
            </button>
            :
            <button type='button' disabled={loader} onClick={() => downloadFile(report_id, title)} style={{ background: background }} className="btn btn-sm  text-white ">
                <div className='d-flex align-items-center justify-content-center fs-6 ps-0 pe-0'>
                    <div class="symbol symbol-25px symbol-circle me-2">
                        <span class={`symbol-label fs-6 fw-semibold text-dark bg-white`}>{order}
                        </span>

                    </div> {title} {loader && <Downloadloader />}
                    <i className="bi-solid bi-chevron-right"></i>
                </div>
            </button>
        }

        <Modal className={'modal-lg'} show={isModalOpen} onHide={() => setIsModalOpen(false)}>
            <Modal.Header className='h-20px bg-dark text-white' closeButton>  <h4 className="fw-semibold text-white fs-5 py-1"> {title} Report</h4></Modal.Header>
            <Modal.Body className='bg-gray-300'>
                {loader && <div style={{ ...styles, position: 'absolute', textAlign: 'center' }}>
                    <button class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span> Loading...
                    </button>
                </div>}
                <div className='px-5'>

                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed p-6">
                        <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="currentColor"></path>
                                <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="currentColor"></path>
                            </svg>
                        </span>
                        <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                            <div className="mb-3 mb-md-0 fw-semibold">
                                <h5 className="text-gray-900 fw-semibold">Report</h5>
                                <div className="fs-7 text-gray-700 pe-7">
                                    Two-factor authentication adds an extra layer of security to your account. To log in,
                                    in addition you'll need to provide 4 digit code
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <label className="col-lg-4 col-form-label required fw-semibold fs-6">Select Days</label>
                            <div className="row">
                                <div className="col-lg-12 fv-row">
                                    <div className="form-check form-check-inline">
                                        <input
                                            type='radio'
                                            onChange={() => { setDays(7) }}
                                            name='status'
                                            id={'inlineenabled7'}
                                            className={clsx('form-check-input')}
                                            autoComplete='off'
                                            value={7}
                                            checked={days === 7}

                                        />
                                        <label className="form-check-label" for="inlineenabled7">
                                            <span className="form-check-label ms-0 fw-semibold fs-6 text-gray-700">Last 7 days</span>
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type='radio'
                                            onChange={() => { setDays(15) }}
                                            id={'inlinedisabled15'}
                                            name='status'
                                            className={clsx(
                                                'form-check-input',
                                            )}
                                            autoComplete='off'
                                            value={15}
                                            checked={days === 15}

                                        />
                                        <label className="form-check-label" for="inlinedisabled15">
                                            <span className="form-check-label ms-0 fw-semibold fs-6 text-gray-700">Last 15 Days</span>
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type='radio'
                                            onChange={() => { setDays(30) }}
                                            id={'inlinedisabled20'}
                                            name='status'
                                            className={clsx(
                                                'form-check-input',
                                            )}
                                            autoComplete='off'
                                            value={20}
                                            checked={days === 30}

                                        />
                                        <label className="form-check-label" for="inlinedisabled20">
                                            <span className="form-check-label ms-0 fw-semibold fs-6 text-gray-700">Last 30 Days</span>
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type='radio'
                                            onChange={() => { setDays(1) }}
                                            id={'inlinedisabled1'}
                                            name='status'
                                            className={clsx(
                                                'form-check-input',
                                            )}
                                            autoComplete='off'
                                            value={1}
                                            checked={days === 1}

                                        />
                                        <label className="form-check-label" for="inlinedisabled1">
                                            <span className="form-check-label ms-0 fw-semibold fs-6 text-gray-700">All</span>
                                        </label>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <div className='card-footer p-2'>
                <div className="d-flex  justify-content-end">
                    {/*begin::Button onClick={() => reportDownLoad()}*/}

                    {download_url && download_url[days] ?
                        // <button onClick={() => downloadFileByDays(report_id, days)} type="button" className="btn btn-sm btn-primary"
                        //     disabled={loader || !days}>
                        //     <span className="indicator-label">{"Download"}</span>
                        //     <span className="indicator-progress">Please wait...
                        //         <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                        // </button>
                        <a href={download_url[days]} target='_blank' rel="noreferrer" download >
                            <button type="button" className="btn btn-sm btn-primary"
                                disabled={loader || !days}>
                                <span className="indicator-label">{"Download"}</span>
                                <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                            </button>
                        </a>
                        : <div className='d-flex flex-column' >
                            <span className='text-danger fw-semibold'>Dwonload Url not set in DB</span>
                            <button type="submit" className="btn btn-sm btn-primary" disabled={true}>
                                <span className="indicator-label">{"Download"}</span>
                                <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                            </button>
                        </div>
                    }
                    {/*end::Button*/}
                </div>
            </div>
        </Modal>
    </>
    )
}

export { ReportButton }

